export const environment = {
  production: false,
  evaluationScheduleDayUtc: 1,
  apiUrl: 'https://admin.smart-fix.development.sfx-dev.aws.domgencloud.net',
  cognitoAuthority:
    'https://cognito-idp.eu-west-2.amazonaws.com/eu-west-2_0Lb0Nidfi',
  cognitoClientId: '62t6rrli9breoeh0phpl00bofi',
  redirectUrl:
    'https://sf-admin-portal.e2e-domgendotcom-dev.aws.domgencloud.net',
};
